// extracted by mini-css-extract-plugin
module.exports = {"design-lab-header":"style-design-lab-header-2ux5C","navtabs":"style-navtabs-14C_M","nav-item":"style-nav-item-3GiTF","menu":"style-menu-2tamT"};